export default __webpack_public_path__ + "static/media/detailsCorrection.694e6308.svg";